// The theme defaults, mirrored from functions/lib/theme.js so the wizard opens
// showing exactly what the server would have stored for an empty theme.
// theme.parity.test.ts asserts the two objects are identical.

import type { AgentTheme } from "./types";

export const DEFAULT_THEME: AgentTheme = {
  primaryColor: "#4F46E5",
  bubbleColor: "#4F46E5",
  textColor: "#111827",
  backgroundColor: "#FFFFFF",
  mode: "auto",
  position: "bottom-right",
  bubbleShape: "round",
  title: "Ask us anything",
  subtitle: "",
  welcomeMessage: "Hi! What can I help you with?",
  placeholder: "Type your question...",
  avatarUrl: "",
  fontFamily: "system",
  showBranding: true,
  sound: "person"
};
